import { State } from 'redux/types';

export const isDarkThemeSelector = (state: State): boolean =>
  state.theme.isDarkTheme;
